/* LILINMOMO rainbow-builder.js — 06 §4.4/§4.5/§6/§8/§9/§10 (BUILD_04 Batches E–F)
   Single vanilla module. All interaction; addToCart() validates (§10) then POSTs the
   §8 line-item-property payload to /cart/add.js, with Dawn cart-drawer integration.
   data-band is the attribute convention; DOM classes match rainbow-builder.css. */

(function () {
  'use strict';

  var root = document.querySelector('[data-rainbow-builder]');
  if (!root) return;

  /* ── tracking (BUILD tracking batch 4) — non-ecommerce rainbow_* events, pushed
     directly (no ecommerce:null reset, unlike lmDL.push). Guarded so a missing
     window.lmDL/dataLayer, or any error in a caller building the params, can
     never throw or block the builder — tracking failure must never break it. ── */
  function dlPush(eventName, params) {
    if (!window.lmDL || !window.dataLayer) return;
    var payload = { event: eventName };
    for (var k in params) { if (params[k] !== null && params[k] !== undefined) payload[k] = params[k]; }
    window.dataLayer.push(payload);
  }
  var colorChangeTimers = {}; // band index -> debounce timer id (rainbow_color_change, 500ms)
  var lastDesignSaveAt = 0;   // throttle gate (rainbow_design_save, 1000ms)
  var VALIDATION_ERROR_CODES = {
    'Pick a shape.': 'no_shape',
    'The colours don’t match this shape — hit Reset and try again.': 'color_count_mismatch',
    'Give every band a valid colour.': 'invalid_color',
    'Pick a size.': 'no_size',
    'Pick an orientation.': 'no_orientation'
  };

  /* ── config ─────────────────────────────────────────── */
  function parseJSON(sel, fallback) {
    try {
      var el = root.querySelector(sel);
      return el ? JSON.parse(el.textContent) : fallback;
    } catch (e) { return fallback; }
  }
  var shapesArr = parseJSON('[data-shapes-config]', []);
  var palettesArr = parseJSON('[data-palettes-config]', [])
    .filter(function (p) { return p && p.active !== false; }); // hide inactive palettes
  var moneyFormat = '${{amount}}';
  var variantLookup = (function () {
    var raw = parseJSON('[data-variant-lookup]', {});
    var out = {};
    for (var k in raw) {
      if (!Object.prototype.hasOwnProperty.call(raw, k)) continue;
      if (k === 'moneyFormat') { moneyFormat = raw[k] || moneyFormat; continue; }
      out[String(k).trim()] = raw[k];
    }
    return out;
  })();
  var builderConfig = parseJSON('[data-builder-config]', {});
  var shapeProducts = parseJSON('[data-shape-products]', {});

  // Shopify's classic money-format algorithm (Shopify.formatMoney), vanilla — mirrors the
  // copy in section-storybook-product.js, which is scoped inside that file's own IIFE and
  // not exposed globally, so it can't be called from here without changing that file.
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = (typeof thousands === 'undefined') ? ',' : thousands;
      decimal = (typeof decimal === 'undefined') ? '.' : decimal;

      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return match ? formatString.replace(placeholderRegex, value) : (formatString + value);
  }
  var shapeDims = parseJSON('[data-shape-dims]', {}); // handle→label→dims (06-rev2 Option B)

  var assetBase = root.dataset.assetBase || '';
  var defaultShape = root.dataset.defaultShape || 'rainbow';
  var colorInputMode = root.dataset.colorInputMode || 'native_with_hex';
  var cartBehavior = root.dataset.cartBehavior || 'open_drawer';
  var autosave = root.dataset.autosave === 'true';
  var builderVersion = root.dataset.builderVersion || builderConfig.builderVersion || '1';

  var shapes = {}; shapesArr.forEach(function (s) { shapes[s.handle] = s; });
  var palettes = {}; palettesArr.forEach(function (p) { palettes[p.id] = p; });

  var els = {
    preview: root.querySelector('[data-preview]'),
    modeTabs: Array.prototype.slice.call(root.querySelectorAll('[data-mode-toggle] button')),
    modePanels: {
      builder: root.querySelector('[data-mode-panel="builder"]'),
      mockup: root.querySelector('[data-mode-panel="mockup"]'),
      size: root.querySelector('[data-mode-panel="size"]'),
      orient: root.querySelector('[data-mode-panel="orient"]')
    },
    mockupImg: root.querySelector('[data-mockup-img]'),
    sizeDiagram: root.querySelector('[data-size-diagram]'),
    sizeDiagramLabel: root.querySelector('[data-size-diagram-label]'),
    sizeDiagramDim: root.querySelector('[data-size-diagram-dim]'),
    orientDiagram: root.querySelector('[data-orient-diagram]'),
    orientDiagramLabel: root.querySelector('[data-orient-diagram-label]'),
    shapePicker: root.querySelector('[data-shape-picker]'),
    bandPicker: root.querySelector('[data-band-picker]'),
    bandLegend: root.querySelector('[data-band-legend]'),
    presetBlock: root.querySelector('[data-preset-block]'),
    presetGrid: root.querySelector('[data-preset-grid]'),
    sizeBlock: root.querySelector('[data-size-block]'),
    sizeSeg: root.querySelector('[data-size-picker]'),
    sizeLegend: root.querySelector('[data-size-legend]'),
    sizeNote: root.querySelector('[data-size-note]'),
    orientWrap: root.querySelector('[data-orientation-picker]'),
    orientSeg: root.querySelector('[data-orientation-seg]'),
    summaryShape: root.querySelector('[data-summary-shape]'),
    summarySize: root.querySelector('[data-summary-size]'),
    summarySizeWrap: root.querySelector('[data-summary-size-wrap]'),
    summaryOrientWrap: root.querySelector('[data-summary-orientation]'),
    summaryOrientVal: root.querySelector('[data-summary-orientation-value]'),
    resetBtn: root.querySelector('[data-reset]'),
    addBtn: root.querySelector('[data-add-to-cart]'),
    addBtnPrice: root.querySelector('[data-add-to-cart-price]'),
    error: root.querySelector('[data-error]')
  };

  /* ── empty-data guard. Shown to shoppers if the rainbow_shape metaobjects aren't
     available; the dev pointer lives in an HTML comment, not the visible message.
     DEV: no rainbow_shape metaobjects seeded — see admin-setup-checklist.md Part 9. ── */
  if (!shapesArr.length) {
    if (els.preview) {
      els.preview.textContent = 'This builder is temporarily unavailable. Please check back soon.';
    }
    return;
  }

  /* ── state (§4.5) ───────────────────────────────────── */
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
  var state = {
    shape: null, colors: [], size: null, orientation: null,
    source: 'custom', paletteId: null, builderVersion: builderVersion
  };
  var currentSVG = null;
  var mode = 'builder';

  /* ── helpers ────────────────────────────────────────── */
  function normHex(c) {
    if (!c) return '#000000';
    return ('#' + String(c).replace('#', '')).toUpperCase();
  }
  function sizeValues(shape) {
    return (shape.size_values || []).map(function (v) {
      var entry = typeof v === 'string' ? { label: v } : v;
      if (typeof entry.label === 'string') entry.label = entry.label.trim();
      return entry;
    });
  }
  function dimsFor(handle, sizeLabel) {
    var m = shapeDims[handle];
    if (!m || !sizeLabel) return '';
    if (m[sizeLabel]) return m[sizeLabel];
    // resilient: tolerate trailing space / casing differences in seeded labels
    var key = String(sizeLabel).trim().toLowerCase();
    for (var k in m) { if (k.toLowerCase() === key) return m[k]; }
    return '';
  }
  function updateSeg(container, value) {
    if (!container) return;
    container.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-v') === value ? 'true' : 'false');
    });
  }
  // Booleans now serialise as real true/false from the config snippet (the | json
  // filter errors on metaobject booleans, so the snippet emits them via {% if %}).
  function isMirrorable(shape) { return shape.orientation_enabled === true; }
  // Orientation that triggers the horizontal flip — per shape, from mirror_value.
  // elongated-corner draws facing left → flip on "Right"; fountain-rainbow draws
  // facing right → flip on "Left" (its metaobject mirror_value must be "Left").
  function mirrorOf(shape) { return shape.mirror_value || 'Right'; }
  // Single source of truth for the flip decision (live preview + orientation diagram).
  function shouldFlip(shape) {
    return isMirrorable(shape) && state.orientation === mirrorOf(shape);
  }
  // Default orientation for a shape: its first option, falling back to mirror_value;
  // null for non-mirrorable shapes.
  function defaultOrientation(shape) {
    return isMirrorable(shape) ? ((shape.orientation_values || [])[0] || mirrorOf(shape)) : null;
  }
  function firstSize(shape) {
    var v = sizeValues(shape);
    return v.length ? v[0].label : null;
  }

  /* ── SVG cache + recolor (§5.2) ─────────────────────── */
  var svgCache = {};
  function fetchSVG(handle) {
    if (svgCache[handle]) return Promise.resolve(svgCache[handle]);
    // Use each shape's canonical asset_url (emitted by the config snippet — correct
    // path + ?v= cache-buster), not a concatenated base. Fallback kept for safety.
    var url = (shapes[handle] && shapes[handle].svg_url)
      ? shapes[handle].svg_url
      : assetBase + 'shape-' + handle + '.svg';
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (t) { svgCache[handle] = t; return t; });
  }
  function svgFromText(text) {
    var doc = new DOMParser().parseFromString(text, 'image/svg+xml');
    // Guard: a 404/non-SVG body yields a <parsererror> doc — never inject it.
    if (doc.getElementsByTagName('parsererror').length ||
        doc.documentElement.nodeName.toLowerCase() !== 'svg') {
      return null;
    }
    return doc.documentElement;
  }
  function setBandColors(svg, colors) {
    svg.querySelectorAll('[data-band]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-band'), 10);
      if (colors[n - 1]) el.setAttribute('fill', colors[n - 1]);
    });
  }
  function applyBandColor(n, color) {
    if (!currentSVG) return;
    currentSVG.querySelectorAll('[data-band="' + n + '"]').forEach(function (el) {
      el.setAttribute('fill', color);
    });
  }
  function applyMirror() {
    if (!currentSVG) return;
    currentSVG.style.transform = shouldFlip(shapes[state.shape]) ? 'scaleX(-1)' : '';
  }

  /* ── multi-mode stage (builder / mockup / size / orient) ── */
  function configureModes() {
    var shape = shapes[state.shape];
    var avail = {
      builder: true,
      mockup: !!shape.mockup_url,
      // Every shape has a size view, so the Size tab is always present: 9 sized shapes
      // show a measured diagram (arch or vertical); polka-dots shows a fixed-dot
      // reference. sizeKind() never returns null, so this is true for all 10.
      size: !!sizeKind(shape),
      orient: isMirrorable(shape)
    };
    els.modeTabs.forEach(function (b) { b.hidden = !avail[b.getAttribute('data-mode')]; });
  }
  function setMode(m) {
    // Never activate a mode whose tab isn't available for this shape (e.g. a stale
    // 'size' carried over to polka-dots) — fall back to the shape's default view.
    var tab = els.modeTabs.filter(function (b) { return b.getAttribute('data-mode') === m; })[0];
    if (!els.modePanels[m] || (tab && tab.hidden)) {
      m = (shapes[state.shape] && shapes[state.shape].mockup_url) ? 'mockup' : 'builder';
    }
    mode = m;
    Object.keys(els.modePanels).forEach(function (k) {
      if (els.modePanels[k]) els.modePanels[k].classList.toggle('is-active', k === m);
    });
    els.modeTabs.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false');
    });
    if (m === 'mockup') {
      var url = shapes[state.shape] && shapes[state.shape].mockup_url;
      if (url && els.mockupImg && els.mockupImg.getAttribute('src') !== url) {
        els.mockupImg.src = url;
        els.mockupImg.alt = shapes[state.shape].label + ' styled in a room';
      }
    } else if (m === 'size') { renderSizeDiagram(); }
    else if (m === 'orient') { renderOrientDiagram(); }
  }

  function parseDims(str) {
    if (!str) return null;
    var nums = (str.match(/\d+(?:\.\d+)?/g) || []).map(Number);
    if (str.indexOf('×') !== -1 && nums.length >= 2) return { width: nums[0], height: nums[1] };
    if (nums.length >= 1) return { width: 0, height: nums[0] }; // single dim (e.g. "108″ Long")
    return null;
  }
  function innerSVG(text) {
    return text.replace(/^[\s\S]*?<svg[^>]*>/, '').replace(/<\/svg>\s*$/, '');
  }
  // Read the viewBox from the SVG file itself — the metaobject's viewbox field can
  // be blank, which previously collapsed the embedded shape to nothing.
  function viewBoxOf(text) {
    var m = text && text.match(/viewBox\s*=\s*["']([^"']+)["']/i);
    if (!m) return null;
    var v = m[1].trim().split(/[\s,]+/).map(Number);
    return (v.length === 4 && v[2] > 0 && v[3] > 0) ? v : null;
  }

  /* ── shape classification — from reliable boolean/number fields, never the flaky
     shape_type text field. ──────────────────────────────────────────────────────── */
  // Verticals (stripes, birch) carry unit_width_in; all other sized shapes don't.
  function isVerticalShape(shape) { return !!shape.unit_width_in; }
  // Size-view kind, driving both the Size tab and its diagram:
  //   'vertical'  → stripes/birch: 7" width + length marks
  //   'arch'      → other sized shapes: width + height marks
  //   'fixed-dot' → polka-dots (the only no-size shape): one dot @ 5" diameter
  function sizeKind(shape) {
    if (!shape.size_enabled) return 'fixed-dot';
    return isVerticalShape(shape) ? 'vertical' : 'arch';
  }

  /* ── size-diagram drawing — shared SVG-string builders + per-kind mark helpers.
     All work in the composite's 600×300 coordinate space. `g` is the geometry box
     { x0,y0,x1,y1,dispW,vb } for the embedded shape. ───────────────────────────── */
  var DIAG_VW = 600, DIAG_VH = 300, DIAG_FONT = 'Nunito, sans-serif', DIAG_T = 7;
  var DIAG_FS = 24, DIAG_FSW = 19; // numeric dims big; wordy labels slightly smaller
  function dLine(a, b, c, d, w, opacity) {
    return '<line x1="' + a + '" y1="' + b + '" x2="' + c + '" y2="' + d +
      '" stroke="currentColor" stroke-width="' + (w || 1.5) + '"' +
      (opacity ? ' stroke-opacity="' + opacity + '"' : '') + '/>';
  }
  function dText(x, y, s, anchor, size, halo) {
    return '<text x="' + x + '" y="' + y + '" font-family="' + DIAG_FONT +
      '" font-weight="600" font-size="' + size + '" text-anchor="' + anchor +
      '" dominant-baseline="middle" fill="currentColor"' +
      (halo ? ' stroke="var(--paper-tint)" stroke-width="4" paint-order="stroke" stroke-linejoin="round"' : '') +
      '>' + s + '</text>';
  }
  // tick = short perpendicular cap at a dimension-line end.
  function vTick(x, y) { return dLine(x - DIAG_T / 2, y, x + DIAG_T / 2, y); } // for a vertical line end
  function hTick(x, y) { return dLine(x, y - DIAG_T / 2, x, y + DIAG_T / 2); } // for a horizontal line end

  // ARCH/SCATTER: width (bottom) + height (left), from dimsFor.
  function drawArchMarks(g, dims) {
    if (!dims) return '';
    var dm = '';
    if (dims.height) {
      var lx = g.x0 - 28;
      dm += dLine(lx, g.y0, lx, g.y1) + vTick(lx, g.y0) + vTick(lx, g.y1)
          + dText(lx - 12, (g.y0 + g.y1) / 2, dims.height + '"', 'end', DIAG_FS);
    }
    if (dims.width) {
      var lyb = g.y1 + 26;
      dm += dLine(g.x0, lyb, g.x1, lyb) + hTick(g.x0, lyb) + hTick(g.x1, lyb)
          + dText((g.x0 + g.x1) / 2, lyb + DIAG_FS, dims.width + '"', 'middle', DIAG_FS);
    }
    return dm;
  }

  // VERTICAL (stripes/birch): ALWAYS both — (a) 7" width across one unit (unit_width_in)
  // and (b) the selected length down the left (dimsFor). Faint per-unit dividers too.
  function drawVerticalMarks(g, shape, dims, dimsStr) {
    var n = shape.stripe_count || 7, unitW = g.dispW / n, dividers = '';
    for (var i = 1; i < n; i++) {
      var ux = g.x0 + unitW * i;
      dividers += dLine(ux, g.y0, ux, g.y1, 1, 0.18);
    }
    // (a) 7" width across one unit
    var lyw = g.y1 + 24;
    var widthMark = dLine(g.x0, lyw, g.x0 + unitW, lyw) + hTick(g.x0, lyw) + hTick(g.x0 + unitW, lyw)
        + dText(g.x0 + unitW / 2, lyw + DIAG_FSW, (shape.unit_width_in || 7) + '" wide', 'middle', DIAG_FSW);
    // (b) length down the left
    var lenLabel = (dims && dims.height) ? dims.height + '" Long' : (dimsStr || state.size || '');
    var lxv = g.x0 - 28;
    var lengthMark = dLine(lxv, g.y0, lxv, g.y1) + vTick(lxv, g.y0) + vTick(lxv, g.y1)
        + dText(lxv - 12, (g.y0 + g.y1) / 2, lenLabel, 'end', DIAG_FSW);
    return dividers + widthMark + lengthMark;
  }

  // FIXED-DOT (polka-dots): measure one real dot via getBBox and draw a 5" diameter
  // callout BESIDE it (a vertical dimension line clear to the dot's right, label
  // further right) — never on top of the dot. DOM op: runs after the art is injected.
  function drawDotMark(composite, inner, g, shape) {
    try {
      var dotEl = inner.querySelector('[data-band]');
      var bb = dotEl && dotEl.getBBox ? dotEl.getBBox() : null;
      if (!bb || !(bb.width > 0)) return;
      var s = g.dispW / g.vb[2]; // meet scale (box sized to art aspect → uniform, no offset)
      var dcx = g.x0 + (bb.x + bb.width / 2 - g.vb[0]) * s;
      var dcy = g.y0 + (bb.y + bb.height / 2 - g.vb[1]) * s;
      var dr = (bb.width / 2) * s;
      var lineX = dcx + dr + 14, top = dcy - dr, bot = dcy + dr;
      composite.insertAdjacentHTML('beforeend',
        dLine(dcx + dr, top, lineX, top, 1) +              // extension from dot edge → line
        dLine(dcx + dr, bot, lineX, bot, 1) +
        dLine(lineX, top, lineX, bot) +                    // vertical diameter line
        vTick(lineX, top) + vTick(lineX, bot) +            // horizontal end caps
        dText(lineX + 10, dcy, (shape.fixed_dot_size_in || 5) + '"', 'start', DIAG_FS, true));
    } catch (e) { /* getBBox unavailable — art + text annotation still show */ }
  }

  function renderSizeDiagram() {
    var shape = shapes[state.shape];
    var kind = sizeKind(shape);
    // Sized kinds need a chosen size; the fixed-dot reference does not.
    if (kind !== 'fixed-dot' && !state.size) { els.sizeDiagram.innerHTML = ''; return; }
    var handle = state.shape;
    fetchSVG(handle).then(function (text) {
      if (state.shape !== handle) return; // shape changed mid-fetch — stale result, drop it
      var vb = viewBoxOf(text) || [0, 0, 1, 1];
      var aspect = vb[2] / vb[3];                 // true art aspect (W/H) — drives the box
      var dimsStr = (kind === 'fixed-dot') ? '' : dimsFor(state.shape, state.size);
      var dims = parseDims(dimsStr);
      if (kind === 'fixed-dot') {
        els.sizeDiagramLabel.textContent = 'One fixed size';
        els.sizeDiagramDim.textContent = 'Each dot is ' + (shape.fixed_dot_size_in || 5) + '" in diameter';
      } else {
        els.sizeDiagramLabel.textContent = state.size;
        els.sizeDiagramDim.textContent = dimsStr || '';
      }

      // Box is sized to the ART aspect so the shape never distorts. Arches scale within
      // their size series (bigger size → bigger box); verticals + the fixed-dot view
      // use a constant size that fits the frame.
      var dispW, dispH;
      if (kind === 'arch') {
        var longDim = dims ? Math.max(dims.width, dims.height) : 0, maxLong = 0;
        sizeValues(shape).forEach(function (sv) {
          var d = parseDims(dimsFor(state.shape, sv.label));
          if (d) maxLong = Math.max(maxLong, Math.max(d.width, d.height));
        });
        var scale = (longDim && maxLong) ? 0.55 + 0.45 * (longDim / maxLong) : 1;
        var mbW = 430 * scale, mbH = 210 * scale;
        if (aspect > mbW / mbH) { dispW = mbW; dispH = mbW / aspect; }
        else { dispH = mbH; dispW = dispH * aspect; }
      } else {
        dispH = 220; dispW = dispH * aspect;
        if (dispW > 470) { dispW = 470; dispH = dispW / aspect; }
      }
      if (!(dispH > 4)) dispH = 180;
      if (!(dispW > 4)) dispW = Math.max(40, dispH * aspect);

      var cx = DIAG_VW / 2, cy = DIAG_VH / 2 - 10;
      var g = {
        x0: cx - dispW / 2, y0: cy - dispH / 2,
        x1: cx + dispW / 2, y1: cy + dispH / 2,
        dispW: dispW, vb: vb
      };

      var dm = (kind === 'vertical') ? drawVerticalMarks(g, shape, dims, dimsStr)
             : (kind === 'arch') ? drawArchMarks(g, dims)
             : ''; // fixed-dot mark is drawn after injection (needs getBBox)

      els.sizeDiagram.innerHTML =
        '<svg viewBox="0 0 ' + DIAG_VW + ' ' + DIAG_VH + '" xmlns="http://www.w3.org/2000/svg">' +
          '<svg x="' + g.x0 + '" y="' + g.y0 + '" width="' + dispW + '" height="' + dispH +
            '" viewBox="' + vb.join(' ') + '" preserveAspectRatio="xMidYMid meet">' + innerSVG(text) + '</svg>' +
          dm +
        '</svg>';
      var composite = els.sizeDiagram.firstElementChild;
      var inner = els.sizeDiagram.querySelector('svg svg');
      if (inner) setBandColors(inner, state.colors);
      if (kind === 'fixed-dot' && inner && composite) drawDotMark(composite, inner, g, shape);
    }).catch(function () {});
  }

  function renderOrientDiagram() {
    var shape = shapes[state.shape];
    var handle = state.shape;
    fetchSVG(handle).then(function (text) {
      if (state.shape !== handle) return; // shape changed mid-fetch — stale result, drop it
      var svg = svgFromText(text);
      if (!svg) return;
      setBandColors(svg, state.colors);
      svg.removeAttribute('width'); svg.removeAttribute('height');
      svg.style.maxHeight = '220px'; svg.style.width = 'auto'; svg.style.height = 'auto';
      svg.style.margin = '0 auto'; svg.style.display = 'block';
      // Same per-shape rule as the live preview, so diagram and preview always agree.
      svg.style.transform = shouldFlip(shape) ? 'scaleX(-1)' : 'none';
      els.orientDiagram.replaceChildren(svg);
      els.orientDiagramLabel.textContent = 'To the ' + (state.orientation || '');
    }).catch(function () {});
  }

  /* ── downsample (§6.1, verbatim) ────────────────────── */
  function downsamplePalette(palette, stripeCount, shapeType) {
    if (palette.length !== 7) {
      throw new Error('downsamplePalette: palette must have exactly 7 entries');
    }
    var INDEX_MAP = { 7: [0, 1, 2, 3, 4, 5, 6], 6: [0, 1, 2, 3, 5, 6], 5: [0, 1, 2, 5, 6] };
    var indices = INDEX_MAP[stripeCount];
    if (!indices) {
      throw new Error('downsamplePalette: unsupported stripeCount ' + stripeCount);
    }
    var result = indices.map(function (i) { return palette[i]; });
    if (shapeType === 'vertical') { result = result.reverse(); }
    return result;
  }

  /* ── localStorage (§9) ──────────────────────────────── */
  function hydrate(handle) {
    if (!autosave) return null;
    try {
      var raw = localStorage.getItem('lmm:builder:v1:' + handle);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() - parsed.savedAt > THIRTY_DAYS_MS) {
        localStorage.removeItem('lmm:builder:v1:' + handle);
        return null;
      }
      return parsed;
    } catch (e) { return null; }
  }
  var saveTimer;
  function persistState() {
    if (!autosave) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        localStorage.setItem('lmm:builder:v1:' + state.shape, JSON.stringify({
          colors: state.colors, size: state.size, orientation: state.orientation,
          source: state.source, paletteId: state.paletteId, savedAt: Date.now()
        }));
        localStorage.setItem('lmm:builder:v1:lastShape', state.shape);
        // rainbow_design_save — throttled to at most 1/sec, not debounced: fires on
        // the leading save within any 1000ms window rather than waiting for quiet.
        var now = Date.now();
        if (now - lastDesignSaveAt >= 1000) {
          lastDesignSaveAt = now;
          dlPush('rainbow_design_save', {
            shape_handle: state.shape,
            source: state.source,
            palette_id: state.source !== 'custom' ? state.paletteId : undefined
          });
        }
      } catch (e) { /* quota/disabled — silent no-op */ }
    }, 200);
  }

  /* ── renders ────────────────────────────────────────── */
  function updateShapeSelected() {
    els.shapePicker.querySelectorAll('.rainbow-builder__shape-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-shape-button') === state.shape ? 'true' : 'false');
    });
  }

  function renderShapePicker() {
    shapesArr.forEach(function (s) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rainbow-builder__shape-btn';
      btn.setAttribute('data-shape-button', s.handle);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', s.label);
      btn.addEventListener('click', function () {
        // Each shape is its own product (own variants/price/title/image) — cross-product
        // shape switches must navigate, not swap art in place, or the variant lookup, price,
        // and cart line item all stay bound to whichever product page is actually loaded.
        var targetUrl = shapeProducts[s.handle];
        if (s.handle !== builderConfig.productShape && targetUrl) {
          window.location.assign(targetUrl);
          return;
        }
        selectShape(s.handle);
      });
      els.shapePicker.appendChild(btn);
      fetchSVG(s.handle).then(function (text) {
        var svg = svgFromText(text);
        if (!svg) return;
        setBandColors(svg, (s.default_colors || []).slice(0, s.stripe_count));
        svg.removeAttribute('width'); svg.removeAttribute('height');
        btn.appendChild(svg);
      }).catch(function () {});
    });
  }

  function renderPreview() {
    var handle = state.shape;
    return fetchSVG(handle).then(function (text) {
      if (state.shape !== handle) return; // shape changed mid-fetch — stale result, drop it
      var svg = svgFromText(text);
      if (!svg) return;
      setBandColors(svg, state.colors);
      svg.removeAttribute('width'); svg.removeAttribute('height');
      svg.style.maxWidth = '100%'; svg.style.maxHeight = '100%';
      svg.style.width = 'auto'; svg.style.height = 'auto'; svg.style.display = 'block';
      els.preview.replaceChildren(svg);
      currentSVG = svg;
      // The stage is a fixed, consistent box (CSS); the SVG scales to fit within it
      // (contain) — tall shapes fill vertically, wide shapes horizontally, same frame.
      applyMirror();
    }).catch(function () {});
  }

  function rowError(row, msg) {
    var e = row.querySelector('.rainbow-builder__row-error');
    if (msg) {
      if (!e) {
        e = document.createElement('span');
        e.className = 'rainbow-builder__row-error';
        e.style.fontSize = '0.75rem';
        e.style.color = 'var(--muted)';
        row.appendChild(e);
      }
      e.textContent = msg;
    } else if (e) { e.remove(); }
  }

  // rainbow_color_change — debounced 500ms per band so dragging a colour picker
  // collapses to one push after a quiet period, keyed by band so switching between
  // two bands within the window still gets one push each, not just the last.
  function scheduleColorChangeEvent(idx, hexValue, source) {
    if (colorChangeTimers[idx]) clearTimeout(colorChangeTimers[idx]);
    colorChangeTimers[idx] = setTimeout(function () {
      delete colorChangeTimers[idx];
      dlPush('rainbow_color_change', {
        shape_handle: state.shape,
        band_index: idx,
        color_hex: hexValue,
        source: source
      });
    }, 500);
  }

  function renderBands() {
    var shape = shapes[state.shape];
    els.bandLegend.textContent = shape.color_label || 'Colors';
    els.bandPicker.querySelectorAll('.rainbow-builder__swatch').forEach(function (r) { r.remove(); });
    for (var i = 0; i < shape.stripe_count; i++) {
      (function (idx) {
        var row = document.createElement('div');
        row.className = 'rainbow-builder__swatch';

        var color = document.createElement('input');
        color.type = 'color';
        color.value = normHex(state.colors[idx]).toLowerCase();
        color.setAttribute('aria-label', 'Band ' + (idx + 1) + ' color');

        var hex = null;
        if (colorInputMode === 'native_with_hex') {
          hex = document.createElement('input');
          hex.type = 'text';
          hex.className = 'rainbow-builder__hex';
          hex.maxLength = 7;
          hex.value = normHex(state.colors[idx]);
          hex.setAttribute('aria-label', 'Band ' + (idx + 1) + ' hex');
        }

        color.addEventListener('input', function () {
          var v = normHex(color.value);
          state.colors[idx] = v;
          state.source = 'custom'; state.paletteId = null;
          applyBandColor(idx + 1, v);
          if (hex) hex.value = v;
          rowError(row, '');
          if (mode !== 'builder') setMode('builder'); // editing colour returns to the live design
          persistState();
          scheduleColorChangeEvent(idx, v, state.source);
        });
        if (hex) {
          hex.addEventListener('change', function () {
            var raw = hex.value.trim();
            if (/^#?[0-9A-Fa-f]{6}$/.test(raw)) {
              var v = normHex(raw);
              state.colors[idx] = v;
              state.source = 'custom'; state.paletteId = null;
              color.value = v.toLowerCase(); hex.value = v;
              applyBandColor(idx + 1, v);
              hex.removeAttribute('aria-invalid');
              rowError(row, '');
              if (mode !== 'builder') setMode('builder');
              persistState();
              scheduleColorChangeEvent(idx, v, state.source);
            } else {
              hex.setAttribute('aria-invalid', 'true');
              rowError(row, 'Use a 6-digit hex, e.g. #C0664A');
            }
          });
        }

        var label = document.createElement('span');
        label.className = 'rainbow-builder__band-label';
        label.textContent = 'Band ' + (idx + 1);

        row.appendChild(color);
        if (hex) row.appendChild(hex);
        row.appendChild(label);
        els.bandPicker.appendChild(row);
      })(i);
    }
  }

  function renderPresets() {
    if (!els.presetGrid) return;
    if (!palettesArr.length) {
      if (els.presetBlock) els.presetBlock.hidden = true;
      return;
    }
    palettesArr.forEach(function (p) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rainbow-builder__preset';
      chip.setAttribute('data-preset-chip', p.id);
      chip.setAttribute('aria-label', p.name);
      var ramp = document.createElement('span');
      ramp.className = 'rainbow-builder__preset-ramp';
      (p.colors || []).forEach(function (c) {
        var i = document.createElement('i');
        i.style.background = c;
        ramp.appendChild(i);
      });
      var name = document.createElement('span');
      name.className = 'rainbow-builder__preset-name';
      name.textContent = p.name;
      chip.appendChild(ramp); chip.appendChild(name);
      chip.addEventListener('click', function () { applyPreset(p.id); });
      els.presetGrid.appendChild(chip);
    });
  }

  function applyPreset(id) {
    var p = palettes[id]; if (!p) return;
    var shape = shapes[state.shape];
    var colors;
    // Verticals reverse the ramp — detect by unit_width_in (reliable), not shape_type.
    try { colors = downsamplePalette(p.colors, shape.stripe_count, isVerticalShape(shape) ? 'vertical' : 'arch'); }
    catch (e) { return; }
    state.colors = colors;
    state.source = 'preset';
    state.paletteId = id;
    if (currentSVG) setBandColors(currentSVG, state.colors);
    renderBands();
    setMode('builder'); // applying a combo shows it live
    persistState();
    dlPush('rainbow_preset_apply', { shape_handle: state.shape, palette_id: id, palette_name: p.name });
  }

  function renderSize() {
    var shape = shapes[state.shape];
    if (!shape.size_enabled) {
      // No size axis (polka-dots): hide the entire "2 · Size" control section — no
      // picker, no note. The dot-size reference lives in the Size preview tab instead.
      els.sizeSeg.replaceChildren();
      if (els.sizeBlock) els.sizeBlock.hidden = true;
      state.size = null;
      return;
    }
    els.sizeSeg.hidden = false;
    if (els.sizeBlock) els.sizeBlock.hidden = false;
    els.sizeLegend.textContent = shape.size_axis_label || 'Size';
    els.sizeSeg.replaceChildren();
    sizeValues(shape).forEach(function (sv) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-v', sv.label);
      btn.setAttribute('aria-pressed', sv.label === state.size ? 'true' : 'false');
      btn.appendChild(document.createTextNode(sv.label));
      var dims = dimsFor(state.shape, sv.label);
      if (dims) {
        var d = document.createElement('span');
        d.className = 'rainbow-builder__dim';
        d.textContent = dims;
        btn.appendChild(d);
      }
      btn.addEventListener('click', function () {
        state.size = sv.label;
        updateSeg(els.sizeSeg, sv.label);
        renderSummary();
        setMode('size'); // show the size-at-scale diagram on selection
        persistState();
        dlPush('rainbow_size_select', { shape_handle: state.shape, size_label: sv.label });
      });
      els.sizeSeg.appendChild(btn);
    });
    renderConstraint();
  }

  function renderOrientation() {
    var shape = shapes[state.shape];
    if (!isMirrorable(shape)) { if (els.orientWrap) els.orientWrap.hidden = true; return; }
    els.orientWrap.hidden = false;
    els.orientSeg.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-v') === state.orientation ? 'true' : 'false');
      b.onclick = function () {
        state.orientation = b.getAttribute('data-v');
        updateSeg(els.orientSeg, state.orientation);
        applyMirror();
        renderSummary();
        setMode('orient'); // show the orientation diagram on selection
        persistState();
        dlPush('rainbow_orientation_toggle', { shape_handle: state.shape, orientation: state.orientation });
      };
    });
  }

  function renderConstraint() {
    if (!els.sizeNote) return;
    var shape = shapes[state.shape];
    // Verticals note their per-panel width; only sized shapes reach here.
    var note = shape.unit_width_in ? shape.unit_width_in + '″ wide per panel · sold by length' : '';
    els.sizeNote.textContent = note;
    els.sizeNote.hidden = !note;
  }

  function renderSummary() {
    var shape = shapes[state.shape];
    els.summaryShape.textContent = shape.label;
    if (shape.size_enabled && state.size) {
      if (els.summarySizeWrap) els.summarySizeWrap.hidden = false;
      var dims = dimsFor(state.shape, state.size);
      els.summarySize.textContent = dims ? state.size + ' (' + dims + ')' : state.size;
    } else {
      if (els.summarySizeWrap) els.summarySizeWrap.hidden = true;
      els.summarySize.textContent = '';
    }
    if (isMirrorable(shape) && state.orientation) {
      els.summaryOrientWrap.hidden = false;
      els.summaryOrientVal.textContent = state.orientation + ' corner';
    } else {
      els.summaryOrientWrap.hidden = true;
    }
    renderPrice();
  }

  // Keeps the add-to-cart button label and the summary line in sync with whatever
  // variant the current size/shape selection resolves to.
  function renderPrice() {
    var cents = resolveVariantPrice();
    var formatted = (cents != null) ? formatMoney(cents, moneyFormat) : '';
    if (els.addBtnPrice) els.addBtnPrice.textContent = formatted ? ' — ' + formatted : '';
  }

  /* ── reset current shape to its defaults (ignores autosave) ── */
  function resetShape() {
    var shape = shapes[state.shape];
    state.colors = (shape.default_colors || []).slice(0, shape.stripe_count);
    state.size = firstSize(shape);
    state.source = 'custom';
    state.paletteId = null;
    state.orientation = defaultOrientation(shape);
    renderBands();
    renderSize();
    renderOrientation();
    renderSummary();
    if (currentSVG) { setBandColors(currentSVG, state.colors); applyMirror(); }
    persistState();
  }

  /* ── shape selection (§4.4 shape:select) ────────────── */
  function selectShape(handle, fromInit) {
    if (!shapes[handle]) return;
    var previousShape = state.shape;
    var prevColors = (state.colors && state.colors.length) ? state.colors.slice() : null;
    state.shape = handle;
    var shape = shapes[handle];

    // Carry over prior session colors when switching shapes (not on initial load).
    // Cycle/repeat if the new shape has more bands than we have prior colors.
    if (!fromInit && prevColors && prevColors.length > 0) {
      var carried = [];
      for (var i = 0; i < shape.stripe_count; i++) {
        carried.push(prevColors[i % prevColors.length]);
      }
      state.colors = carried;
      state.size = firstSize(shape);
      state.source = 'custom';
      state.paletteId = null;
      state.orientation = defaultOrientation(shape);
    } else {
      var saved = hydrate(handle);
      if (saved && Array.isArray(saved.colors) && saved.colors.length === shape.stripe_count) {
        state.colors = saved.colors.slice();
        state.size = saved.size || firstSize(shape);
        state.source = saved.source || 'custom';
        state.paletteId = saved.paletteId || null;
        state.orientation = isMirrorable(shape) ? (saved.orientation || defaultOrientation(shape)) : null;
      } else {
        state.colors = (shape.default_colors || []).slice(0, shape.stripe_count);
        state.size = firstSize(shape);
        state.source = 'custom';
        state.paletteId = null;
        state.orientation = defaultOrientation(shape);
      }
    }

    updateShapeSelected();
    renderBands();
    renderSize();
    renderOrientation();
    renderSummary();
    renderPreview();
    configureModes();
    // Lead with the room mockup ("see it on a wall"); fall back to the live
    // builder if this shape has no mockup. Editing a colour flips to builder.
    setMode(shape.mockup_url ? 'mockup' : 'builder');
    if (!fromInit) persistState();
    if (!fromInit) dlPush('rainbow_shape_select', { shape_handle: handle, previous_shape: previousShape });
  }

  /* ── add to cart (§8 payload, §10 validation) ─────────── */
  function genDesignId() {
    var raw = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID().replace(/-/g, '')
      : (Date.now().toString(16) + Math.random().toString(16).slice(2));
    return raw.slice(0, 8);
  }
  function validSize(shape, size) {
    return sizeValues(shape).some(function (sv) { return sv.label === size; });
  }
  // §10 — returns plain-language problems; [] means valid.
  function validateState() {
    var shape = shapes[state.shape];
    var errors = [];
    if (!shape) { errors.push('Pick a shape.'); return errors; }
    if (state.colors.length !== shape.stripe_count) {
      errors.push('The colours don’t match this shape — hit Reset and try again.');
    } else if (state.colors.some(function (c) { return !/^#[0-9A-Fa-f]{6}$/.test(c); })) {
      errors.push('Give every band a valid colour.');
    }
    if (shape.size_enabled && !validSize(shape, state.size)) errors.push('Pick a size.');
    if (isMirrorable(shape) && state.orientation !== 'Right' && state.orientation !== 'Left') {
      errors.push('Pick an orientation.');
    }
    return errors;
  }

  // §8.3 — sized shapes map size→variant strictly; a miss means the merchant hasn't
  // configured Size variants (→ setup error, never a silent fallback). polka-dots is
  // a single-variant product.
  function firstVariantEntry() {
    for (var k in variantLookup) {
      if (Object.prototype.hasOwnProperty.call(variantLookup, k) && variantLookup[k]) return variantLookup[k];
    }
    return null;
  }
  function firstVariantId() {
    var entry = firstVariantEntry();
    return entry ? entry.id : null;
  }
  function resolveVariantId() {
    var shape = shapes[state.shape];
    if (shape.size_enabled) {
      var entry = variantLookup[state.size];
      return (entry && entry.id) || null;
    }
    return builderConfig.variantId || firstVariantId();
  }
  // Mirrors resolveVariantId()'s two paths so the price shown always matches the
  // variant that would actually be added to cart.
  function resolveVariantPrice() {
    var shape = shapes[state.shape];
    var entry = shape.size_enabled ? variantLookup[state.size] : firstVariantEntry();
    return (entry && typeof entry.price === 'number') ? entry.price : null;
  }

  // §8.1 — built in the visible-then-hidden order for tidy cart display.
  function buildProperties() {
    var shape = shapes[state.shape];
    var props = { 'Shape': shape.label };
    if (shape.size_enabled && state.size) {
      var dims = dimsFor(state.shape, state.size);
      props['Size'] = dims ? state.size + ' (' + dims + ')' : state.size;
    }
    if (isMirrorable(shape)) props['Orientation'] = state.orientation + ' corner';
    props['Colors'] = state.colors.join(', ');
    if (state.source === 'preset' && state.paletteId && palettes[state.paletteId]) {
      props['Palette'] = palettes[state.paletteId].name;
    }
    props['Design ID'] = genDesignId();
    props['_pipeline'] = 'print_and_cut';
    props['_shape'] = state.shape;
    props['_source'] = state.source;
    props['_palette_id'] = state.paletteId || '';
    props['_builder_version'] = state.builderVersion;
    props['_state'] = JSON.stringify(state);
    return props;
  }

  /* ── status messaging (brand-neutral — §8.5/§10.2, no red alarm) + busy state ── */
  function showStatus(msg, success) {
    if (!els.error) return;
    els.error.textContent = msg;
    els.error.hidden = false;
    els.error.classList.toggle('is-success', !!success);
  }
  function clearStatus() {
    if (!els.error) return;
    els.error.textContent = '';
    els.error.hidden = true;
    els.error.classList.remove('is-success');
  }
  function setBusy(b) {
    if (!els.addBtn) return;
    els.addBtn.disabled = b;
    els.addBtn.setAttribute('aria-busy', b ? 'true' : 'false');
  }

  /* ── Dawn cart drawer/notification integration (best-effort) ── */
  function dawnCartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function cartSectionsParam(el) {
    try {
      if (el && el.getSectionsToRender) {
        return el.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      }
    } catch (e) { /* fall through */ }
    return 'cart-icon-bubble';
  }
  function updateCartBubble(response) {
    if (!response || !response.sections || !response.sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    if (src) bubble.innerHTML = src.innerHTML;
  }
  function handleCartSuccess(response, cartEl) {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: response }));

    // Standard GA4 ecommerce add_to_cart (so builder sales show up in GA4's ecommerce
    // reports, same as the PDP), then the rainbow_add_to_cart detail event. Both read
    // the added line back from the /cart/add.js response rather than the DOM/state,
    // since the POST body used the { items: [...] } array form, so the response is
    // always { items: [...] } even for one item — same shape the PDP reads.
    var line = response && response.items && response.items[0];
    if (line) {
      if (window.lmDL) {
        var atcItemVariant = (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : undefined;
        var atcItem = {
          item_id: line.sku || String(line.variant_id),
          item_name: line.product_title,
          item_brand: 'LILINMOMO',
          item_category: line.product_type,
          price: window.lmDL.money(line.price),
          quantity: line.quantity
        };
        if (atcItemVariant) atcItem.item_variant = atcItemVariant;
        window.lmDL.push('add_to_cart', {
          currency: window.lmDL.currency,
          value: window.lmDL.money(line.price) * line.quantity,
          items: [atcItem]
        });
      }
      // genDesignId() only ever runs once, inline inside buildProperties() when the
      // cart POST body was built — it isn't stored on state or anywhere else reachable
      // here, so the design_id (and _builder_version) come back off the line's own
      // properties, which Shopify echoes back exactly as submitted.
      var lineProps = line.properties || {};
      dlPush('rainbow_add_to_cart', {
        shape_handle: state.shape,
        size_label: state.size,
        orientation: state.orientation,
        source: state.source,
        palette_id: state.source !== 'custom' ? state.paletteId : undefined,
        colors: state.colors.join(','),
        design_id: lineProps['Design ID'],
        builder_version: lineProps['_builder_version'],
        value: window.lmDL ? window.lmDL.money(line.price) * line.quantity : undefined
      });
    }

    if (cartBehavior === 'redirect_cart') { window.location.href = '/cart'; return; }
    if (cartBehavior === 'open_drawer' && cartEl && typeof cartEl.renderContents === 'function') {
      cartEl.renderContents(response); // Dawn updates the bubble + opens the drawer/notification
      return;
    }
    // inline_confirm, or open_drawer with no Dawn cart UI present
    updateCartBubble(response);
    showStatus('Added to your cart.', true);
    setTimeout(function () {
      if (els.error && els.error.classList.contains('is-success')) clearStatus();
    }, 4000);
  }

  function addToCart() {
    clearStatus();
    var errors = validateState();
    if (errors.length) {
      showStatus(errors.join(' '), false);
      if (els.addBtn) els.addBtn.focus();
      dlPush('rainbow_validation_error', {
        shape_handle: state.shape,
        error_codes: errors.map(function (msg) { return VALIDATION_ERROR_CODES[msg] || 'unknown'; }).join(',')
      });
      return;
    }
    var variantId = resolveVariantId();
    if (!variantId) {
      showStatus('This product isn’t ready to purchase yet — its Size options need to be set up in the store admin.', false);
      return;
    }

    var cartEl = dawnCartEl();
    var body = { items: [{ id: variantId, quantity: 1, properties: buildProperties() }] };
    if (cartBehavior !== 'redirect_cart') {
      body.sections = cartSectionsParam(cartEl);
      body.sections_url = window.location.pathname;
    }

    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    }).then(function (r) {
      setBusy(false);
      if (!r.ok) {
        // §8.5 — surface Shopify's reason (e.g. 422 sold-out) or a graceful generic.
        showStatus((r.data && r.data.description) || 'We couldn’t add that to your cart. Please try again.', false);
        return;
      }
      handleCartSuccess(r.data, cartEl);
    }).catch(function () {
      // Network error — design stays in the builder + localStorage, nothing lost.
      setBusy(false);
      showStatus('Something went wrong. Please try again — your design is saved.', false);
    });
  }

  /* ── init (§4.4 init) ───────────────────────────────── */
  function init() {
    renderShapePicker();
    renderPresets();
    var initial = (builderConfig.productShape && shapes[builderConfig.productShape])
      ? builderConfig.productShape
      : (shapes[defaultShape] ? defaultShape : shapesArr[0].handle);
    els.modeTabs.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); });
    });
    selectShape(initial, true);
    if (els.addBtn) els.addBtn.addEventListener('click', addToCart);
    if (els.resetBtn) els.resetBtn.addEventListener('click', resetShape);

    if (/[?&]lmm_debug=1/.test(location.search)) {
      window.__lmmBuilder = { state: state, palettes: palettes, shapes: shapes, downsamplePalette: downsamplePalette };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
